import React, {Component} from 'react';

import BaseBtn from '../../Buttons/BaseBtn';

import * as UserService from '../../../services/User/UserService';
import Loading from "../Loading";

const initialState = {
    requestID: '영문 또는 숫자만 입력',
    requestPW: '비밀번호',
    requestPWCheck: '비밀번호 확인',
    requestName: '이름',
    // requestEngName: '영어 이름',
    requestBirthday: '년, 월, 일 순으로 총 8자리 ex.19000101',
    requestShcl: '학교 이름',
    requestGradeList: [
        '-', '초1', '초2', '초3', '초4', '초5', '초6', '중1', '중2', '중3', '고1', '고2', '고3', '기타'
    ],
    requestGrade: null,
    requestParentsCallNum: '숫자만 입력 ex.01012341234',
    requestProfileImg: null,
    requestCallNum: '숫자만 입력 ex.01012341234',
    // requestPhonelNum: '휴대폰',
    // requestMail: 'E-Mail 주소',

    visible: false,
    isStudentForm: true,
    isDuplicated: false,
    isPWTheSame: true,
    // loading
    isLoadingHide: true,
    isAdminMode: false,
    isUpdateMode: false,
    selectStudent: null
}

class PopupRegisterForm extends Component {
    state = {
        // login form
        requestID: '영문 또는 숫자만 입력',
        requestPW: '비밀번호',
        requestPWCheck: '비밀번호 확인',
        requestName: '이름',
        // requestEngName: '영어 이름',
        requestBirthday: '년, 월, 일 순으로 총 8자리 ex.19000101',
        requestShcl: '학교 이름',
        requestGradeList: [
            '-', '초1', '초2', '초3', '초4', '초5', '초6', '중1', '중2', '중3', '고1', '고2', '고3', '기타'
        ],
        requestGrade: null,
        requestParentsCallNum: '숫자만 입력 ex.01012341234',
        requestProfileImg: null,
        requestCallNum: '숫자만 입력 ex.01012341234',
        // requestPhonelNum: '휴대폰',
        // requestMail: 'E-Mail 주소',

        visible: false,
        isStudentForm: true,
        isDuplicated: false,
        isPWTheSame: true,
        // loading
        isLoadingHide: false
    }

    componentDidMount = () => {
        this.setState({
            isLoadingHide: true
        });
    }

    componentWillReceiveProps = (nextProps) => {
        if (this.state.visible != nextProps.active) {
            this.setState({
                visible: nextProps.active,
                isAdminMode: nextProps.isAdminMode,
                isUpdateMode: nextProps.isUpdateMode,
                requestID: (nextProps.isUpdateMode) ? nextProps.student.username : '영문 또는 숫자만 입력',
                requestName: (nextProps.isUpdateMode) ? nextProps.student.name : '이름',
                requestBirthday: (nextProps.isUpdateMode) ? nextProps.student.birth : '년, 월, 일 순으로 총 8자리 ex.19000101',
                requestShcl: (nextProps.isUpdateMode) ? nextProps.student.school : '학교 이름',
                requestParentsCallNum: (nextProps.isUpdateMode) ? nextProps.student.emergencyContactNum : '숫자만 입력 ex.01012341234',
                requestGrade: (nextProps.isUpdateMode) ? nextProps.student.grade : null,
                selectStudent: nextProps.student
            });
        }
    }

    closePopup = () => {
        if (this.state.visible) {
            this.setState(initialState);
            this.props.onCancel();
        }
    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    };

    thumbnailChange = (e) => {
        if (!e.target.files[0].type.includes('image')) {
            alert('이미지 파일을 업로드 해주세요');
            return false;
        }
        const reader = new FileReader();
        const thumbnailImage = e.target.files[0];
        reader.readAsDataURL(thumbnailImage);
        const that = this;
        reader.onload = function () {
            that.setState({
                requestProfileImg: reader.result
            })
        };
    }

    registerFormChoose = (value) => {
        if (value === 'teacher') {
            this.setState({
                isStudentForm: false
            });
        } else {
            this.setState({
                isStudentForm: true
            });
        }
    }

    userDuplicateCheck = () => {
        if (this.state.requestID !== '영문 또는 숫자만 입력') {
            UserService.isUserDuplicated(this.state.requestID).then((response) => {
                if (response !== null && response.status === 200) {
                    this.setState({
                        isDuplicated: response.data.data
                    });
                }
            }).catch((error) => {
                console.info(error);
                alert('SERVER ERROR')
            });
        }
    }

    userPasswordCheck = () => {
        if (this.state.requestPW == this.state.requestPWCheck) {
            this.setState({
                isPWTheSame: true
            });
        } else {
            this.setState({
                isPWTheSame: false
            });
        }
    }

    userValidation = () => {
        if (this.state.isDuplicated) {
            alert('아이디가 이미 사용중입니다.')
            return false;
        }
        if (!this.state.isPWTheSame) {
            alert('비밀번호가 서로 다릅니다.')
            return false;
        }
        if (this.state.requestID == null || (this.state.requestID != null && this.state.requestID.trim() == '')
            || (this.state.requestID != null && this.state.requestID == '영문 또는 숫자만 입력')) {
            alert('아이디를 입력해 주세요.');
            return null;
            // return;
        }
        if (this.state.requestPW == null || (this.state.requestPW != null && this.state.requestPW.trim() == '')
            || (this.state.requestPW != null && this.state.requestPW == '비밀번호')) {
            alert('비밀번호를 입력해 주세요.');
            return false;
        }
        if (this.state.requestPWCheck == null || (this.state.requestPWCheck != null && this.state.requestPWCheck.trim() == '')
            || (this.state.requestPWCheck != null && this.state.requestPWCheck == '비밀번호 확인')) {
            alert('비밀번호를 입력해 주세요.');
            return false;
        }
        if (this.state.requestName == null || (this.state.requestName != null && this.state.requestName.trim() == '')
            || (this.state.requestName != null && this.state.requestName == '이름')) {
            alert('이릅을 입력해 주세요.');
            return false;
        }
        if (this.state.isStudentForm) {
            if (this.state.requestParentsCallNum == null || (this.state.requestParentsCallNum != null && this.state.requestParentsCallNum.trim() == '')
                || (this.state.requestParentsCallNum != null && this.state.requestParentsCallNum == '숫자만 입력 ex.01012341234')) {
                alert('부모님 전화번호를 입력해 주세요.');
                return false;
            } else {
                const regexType = /^01([0|1|6|7|8|9]?)([0-9]{3,4})([0-9]{4})$/;
                if ( !regexType.test(this.state.requestParentsCallNum) ) {
                    alert('올바른 전화번호를 입력해 주세요.');
                    return false;
                }
            }
        } else {
            if (this.state.requestCallNum == null || (this.state.requestCallNum != null && this.state.requestCallNum.trim() == '')
                || (this.state.requestCallNum != null && this.state.requestCallNum == '숫자만 입력 ex.01012341234')) {
                alert('전화번호를 입력해 주세요.');
                return false;
            } else {
                const regexType = /^01([0|1|6|7|8|9]?)([0-9]{3,4})([0-9]{4})$/;
                if ( !regexType.test(this.state.requestCallNum) ) {
                    alert('올바른 전화번호를 입력해 주세요.');
                    return false;
                }
            }
        }
        if( this.state.requestBirthday != null && this.state.requestBirthday != '년, 월, 일 순으로 총 8자리 ex.19000101' && this.state.requestBirthday.trim() != '' ) {
            const regexType = /([12]\d{3}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01]))/;
            if ( !regexType.test(this.state.requestBirthday) || this.state.requestBirthday.length != 8) {
                alert('생년월일을 19001231 형식으로 입력해 주세요.');
                return false;
            }
        }
        return true;
    }

    registerUser = () => {
        if (!this.userValidation()) {
            return false;
        }
        let userVO = {}
        if (!this.state.isStudentForm) {
            userVO = {
                'username': this.state.requestID,
                'password': this.state.requestPW,
                'name': this.state.requestName,
                'birth': this.state.requestBirthday,
                'mobileNum': this.state.requestCallNum,
                'thumbnailImage': this.state.requestProfileImg,
                'identity': 'I_TEACHER'
            };
        } else {
            userVO = {
                'username': this.state.requestID,
                'password': this.state.requestPW,
                'name': this.state.requestName,
                'birth': this.state.requestBirthday,
                'school': this.state.requestShcl,
                'grade': this.state.requestGrade,
                'emergencyContactNum': this.state.requestParentsCallNum,
                'thumbnailImage': this.state.requestProfileImg,
                'identity': 'I_STUDENT'
            };
        }
        this.setState({
            isLoadingHide: false
        });
        UserService.register(userVO).then((response) => {
            if (response !== null && response.status === 200) {
                if (response.data !== null && response.data.code === '0000') {
                    alert('회원 가입을 축하드립니다.');
                    this.setState(initialState);
                    this.props.onConfirm();
                } else {
                    console.log(response);
                    alert('회원 가입을 실패 했습니다.');
                }
            } else {
                console.log(response);
                alert('회원 가입을 실패 했습니다. 지속적으로 문제 발생시 문의해주세요.');
            }
        }).catch((error) => {
            console.log(error);
            alert('SERVER ERROR');
        });
    }

    onUpdate = () => {
        if (!this.userValidation()) {
            return false;
        }
        let userVO = {}
        if (!this.state.isStudentForm) {
            userVO = {
                'username': this.state.requestID,
                'password': this.state.requestPW,
                'name': this.state.requestName,
                'birth': this.state.requestBirthday,
                'mobileNum': this.state.requestCallNum,
                'thumbnailImage': this.state.requestProfileImg,
                'identity': 'I_TEACHER'
            };
        } else {
            userVO = {
                'username': this.state.requestID,
                'password': this.state.requestPW,
                'name': this.state.requestName,
                'birth': this.state.requestBirthday,
                'school': this.state.requestShcl,
                'grade': this.state.requestGrade,
                'emergencyContactNum': this.state.requestParentsCallNum,
                'thumbnailImage': this.state.requestProfileImg,
                'identity': 'I_STUDENT'
            };
        }
        console.log(userVO);
        /*this.setState({
         isLoadingHide: false
         });*/
        UserService.updateStudent(userVO).then((response) => {
            if (response !== null && response.status === 200) {
                if (response.data !== null && response.data.code === '0000') {
                    alert('회원 정보 수정이 완료되었습니다.');
                    this.setState(initialState);
                    this.props.onConfirm();
                } else {
                    console.log(response);
                    alert('회원 정보 수정을 실패 했습니다.');
                }
            } else {
                console.log(response);
                alert('회원 정보 수정을 실패 했습니다. 지속적으로 문제 발생시 문의해주세요.');
            }
        }).catch((error) => {
            console.log(error);
            alert('SERVER ERROR');
        });
    }

    onDelete = () => {

        console.log("id: " + this.state.selectStudent.id);
        UserService.deleteStudent(this.state.selectStudent.id).then((response) => {
            if (response !== null && response.status === 200) {
                if (response.data !== null && response.data.code === '0000') {
                    alert('회원 기록이 삭제되었습니다.');
                    //this.setState(initialState);
                    this.props.onConfirm();
                } else {
                    console.log(response);
                    alert('회원 삭제 실패 했습니다.');
                }
            } else {
                console.log(response);
                alert('회원 삭제 실패 했습니다. 지속적으로 문제 발생시 문의해주세요.');
            }
        }).catch((error) => {
            console.log(error);
            alert('SERVER ERROR');
        });
    }

    render() {
        if (!this.state.isLoadingHide) {
            return (<Loading/>);
        }

        const {requestID, requestPW, requestPWCheck, requestName, requestEngName, requestBirthday, requestShcl, requestGradeList, requestGrade, requestParentsCallNum, requestProfileImg, requestCallNum, requestPhonelNum, requestMail, isUpdateMode} = this.state;
        return (
            this.state.visible ?
                <div className="registerPopupWrapper">
                    <div className="registerPopup">
                        <div className="registerFormWrapper">
                            <div>
                                <h3 className="screenOut">회원가입</h3>
                                <dl className="registerFormContents">
                                    <dt className="registerTitle ">
                                        <span>{(this.state.isUpdateMode) ? "조회/수정/삭제" : "회원가입"}</span>
                                        <button onClick={this.closePopup} className="btnClose">닫기</button>
                                    </dt>
                                    <dd className="contents">
                                        {(!this.props.isAdminMode) &&
                                        <div className="tabMenu">
                                            <ul>
                                                <li>
                                                    <span onClick={() => this.registerFormChoose('student')}
                                                          className={this.state.isStudentForm ? "studentForm active" : "studentForm"}>학생</span>
                                                    <span onClick={() => this.registerFormChoose('teacher')}
                                                          className={this.state.isStudentForm ? "teacherForm" : "teacherForm active"}>선생님</span>
                                                </li>
                                            </ul>
                                        </div>}
                                        <div className="tabContents">
                                            <ul>

                                                {/*STUDENT FORM*/}
                                                <li className={this.state.isStudentForm ? "studentForm active" : "studentForm"}>
                                                    <div className="inputWrapper">
                                                        <ul>
                                                            <li>
                                                                <span className="customInputBox">
                                                                    <label htmlFor="requestID">
                                                                        <span
                                                                            className={this.state.isDuplicated ? "userDuplicate active" : "userDuplicate"}>*아이디</span>
                                                                        <input onBlur={() => this.userDuplicateCheck()}
                                                                               disabled={isUpdateMode}
                                                                               type="text" placeholder={requestID}
                                                                               defaultValue={(isUpdateMode) ? requestID : ''}
                                                                               onChange={this.handleChange}
                                                                               name="requestID"/>
                                                                    </label>
                                                                </span>
                                                            </li>
                                                            <li>
                                                                <span className="customInputBox">
                                                                    <label htmlFor="requestPW">
                                                                        <span
                                                                            className={this.state.isPWTheSame ? "userPassword" : "userPassword active"}>*비밀번호</span>
                                                                        <input type="password" placeholder={requestPW}
                                                                               onChange={this.handleChange}
                                                                               name="requestPW"/>
                                                                    </label>
                                                                </span>
                                                            </li>
                                                            <li>
                                                                <span className="customInputBox">
                                                                    <label htmlFor="requestPW">
                                                                        <span
                                                                            className={this.state.isPWTheSame ? "userPassword" : "userPassword active"}>*비밀번호 확인</span>
                                                                        <input onBlur={() => this.userPasswordCheck()}
                                                                               type="password"
                                                                               placeholder={requestPWCheck}
                                                                               onChange={this.handleChange}
                                                                               name="requestPWCheck"/>
                                                                    </label>
                                                                </span>
                                                            </li>
                                                            <li>
                                                                <span className="customInputBox">
                                                                    <label htmlFor="requestName">
                                                                        <span>*이름</span>
                                                                        <input type="text" placeholder={requestName}
                                                                               onChange={this.handleChange}
                                                                               defaultValue={(isUpdateMode) ? requestName : ''}
                                                                               name="requestName"/>
                                                                    </label>
                                                                </span>
                                                            </li>
                                                            <li>
                                                                <span className="customInputBox">
                                                                    <label htmlFor="requestBirthday">
                                                                        <span>생년월일</span>
                                                                        <input type="number"
                                                                               placeholder={requestBirthday}
                                                                               defaultValue={(isUpdateMode) ? requestBirthday : ''}
                                                                               onChange={this.handleChange}
                                                                               name="requestBirthday"/>
                                                                    </label>
                                                                </span>
                                                            </li>
                                                            <li>
                                                                <span className="customInputBox">
                                                                    <label htmlFor="requestShcl">
                                                                        <span>학교</span>
                                                                        <input type="text" placeholder={requestShcl}
                                                                               defaultValue={(isUpdateMode) ? requestShcl : ''}
                                                                               onChange={this.handleChange}
                                                                               name="requestShcl"/>
                                                                    </label>
                                                                </span>
                                                            </li>
                                                            <li>
                                                                <span className="customInputBox">
                                                                    <label htmlFor="requestGrade">
                                                                        <span>학년</span>
                                                                        <select name="requestGrade"
                                                                                onChange={this.handleChange}
                                                                                value={(requestGrade == null) ? '-' : requestGrade}>
                                                                            {this.state.requestGradeList.map((grade, i) => {
                                                                                return (
                                                                                    <option key={i}> {grade} </option>
                                                                                );
                                                                            })}
                                                                        </select>
                                                                    </label>
                                                                </span>
                                                            </li>
                                                            <li>
                                                                <span className="customInputBox">
                                                                    <label htmlFor="requestParentsCallNum">
                                                                        <span>*부모님 전화번호</span>
                                                                        <input type="number"
                                                                               placeholder={requestParentsCallNum}
                                                                               defaultValue={(isUpdateMode) ? requestParentsCallNum : ''}
                                                                               onChange={this.handleChange}
                                                                               name="requestParentsCallNum"/>
                                                                    </label>
                                                                </span>
                                                            </li>
                                                            <li>
                                                                <span className="customInputBox">
                                                                    <label htmlFor="requestProfileImg">
                                                                        <span>프로필이미지</span>
                                                                        <input type="file"
                                                                               onChange={this.thumbnailChange}
                                                                               name="requestProfileImg"/>
                                                                    </label>
                                                                </span>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    {(this.state.isUpdateMode) ?
                                                        <div className="btnWrapper">
                                                            <BaseBtn btnColor={"blue"} btnName={"수정"}
                                                                     onClick={this.onUpdate}/>
                                                            <BaseBtn btnColor={"deepPink"} btnName={"삭제"}
                                                                     onClick={this.onDelete}/>
                                                        </div> :
                                                        <div className="btnWrapper">
                                                            <BaseBtn btnColor={"deepPink"} btnName={"회원가입"}
                                                                     onClick={this.registerUser}/>
                                                        </div>
                                                    }
                                                </li>


                                                {/*TEACHER FORM*/}
                                                <li className={this.state.isStudentForm ? "teacherForm" : "teacherForm active"}>
                                                    <div className="inputWrapper">
                                                        <ul>
                                                            <li>
                                                                <span className="customInputBox">
                                                                    <label htmlFor="requestID">
                                                                        <span
                                                                            className={this.state.isDuplicated ? "userDuplicate active" : "userDuplicate"}>*아이디</span>
                                                                        <input onBlur={() => this.userDuplicateCheck()}
                                                                               type="text" placeholder={requestID}
                                                                               onChange={this.handleChange}
                                                                               name="requestID"/>
                                                                    </label>
                                                                </span>
                                                            </li>
                                                            <li>
                                                                <span className="customInputBox">
                                                                    <label htmlFor="requestPW">
                                                                        <span
                                                                            className={this.state.isPWTheSame ? "userPassword" : "userPassword active"}>*비밀번호</span>
                                                                        <input type="password" placeholder={requestPW}
                                                                               onChange={this.handleChange}
                                                                               name="requestPW"/>
                                                                    </label>
                                                                </span>
                                                            </li>
                                                            <li>
                                                                <span className="customInputBox">
                                                                    <label htmlFor="requestPW">
                                                                        <span
                                                                            className={this.state.isPWTheSame ? "userPassword" : "userPassword active"}>*비밀번호 확인</span>
                                                                        <input onBlur={() => this.userPasswordCheck()}
                                                                               type="password"
                                                                               placeholder={requestPWCheck}
                                                                               onChange={this.handleChange}
                                                                               name="requestPWCheck"/>
                                                                    </label>
                                                                </span>
                                                            </li>
                                                            <li>
                                                                <span className="customInputBox">
                                                                    <label htmlFor="requestName">
                                                                        <span>*이름</span>
                                                                        <input type="text" placeholder={requestName}
                                                                               onChange={this.handleChange}
                                                                               name="requestName"/>
                                                                    </label>
                                                                </span>
                                                            </li>
                                                            {/*<li>*/}
                                                            {/*<span className="customInputBox">*/}
                                                            {/*<label htmlFor="requestEngName">*/}
                                                            {/*<span>영어이름</span>*/}
                                                            {/*<input type="text" placeholder={requestEngName} onChange={this.handleChange} name="requestEngName"/>*/}
                                                            {/*</label>*/}
                                                            {/*</span>*/}
                                                            {/*</li>*/}
                                                            <li>
                                                                <span className="customInputBox">
                                                                    <label htmlFor="requestBirthday">
                                                                        <span>*생년월일</span>
                                                                        <input type="number"
                                                                               placeholder={requestBirthday}
                                                                               onChange={this.handleChange}
                                                                               name="requestBirthday"/>
                                                                    </label>
                                                                </span>
                                                            </li>
                                                            <li>
                                                                <span className="customInputBox">
                                                                    <label htmlFor="requestCallNum">
                                                                        <span>*전화번호</span>
                                                                        <input type="number"
                                                                               placeholder={requestCallNum}
                                                                               onChange={this.handleChange}
                                                                               name="requestCallNum"/>
                                                                    </label>
                                                                </span>
                                                            </li>
                                                            <li>
                                                                <span className="customInputBox">
                                                                    <label htmlFor="requestProfileImg">
                                                                        <span>프로필이미지</span>
                                                                        <input type="file"
                                                                               onChange={this.thumbnailChange}
                                                                               name="requestProfileImg"/>
                                                                    </label>
                                                                </span>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div className="btnWrapper">
                                                        <BaseBtn btnColor={"deepPink"} btnName={"회원가입"}
                                                                 onClick={this.registerUser}/>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </dd>
                                </dl>
                            </div>
                        </div>
                    </div>
                </div>
                : null
        );
    }
}

PopupRegisterForm.defaultProps = {
    isAdminMode: false,
    isUpdateMode: false,
    onConfirm: () => {
    }
};

export default PopupRegisterForm;


// WEBPACK FOOTER //
// ./src/components/Containers/PopupRegisterForm/index.js